import { getLeafNodes } from 'next/lib/conditions';

/**
 * Split a conditions tree into branches that correspond to the
 * pin targeting sections
 *
 * @param {Conditions} conditions
 * @returns {{audience: {Conditions}, domains: {Conditions}, url: {Conditions}}}}
 */

export const getPinTargetingSections = ({ and: branches = [] } = {}) => ({
  url: branches.find(branch =>
    getLeafNodes(branch).some(({ url }) => Boolean(url))
  ),
  domains: branches.find(branch =>
    getLeafNodes(branch).some(({ domains }) => Boolean(domains))
  ),
  audience: branches.find(branch =>
    getLeafNodes(branch).some(({ url, domains }) => !url && !domains)
  ),
});
